import {
  DELETION_BEGIN,
  DELETION_SUCCESS,
  DELETION_FAILURE,
  DELETION_CLEAR,
} from '../_types'
import auth from '@api/auth'
import getErrorMessage from '@utils/getErrorMessage'

const getDefaultState = () => {
  return {
    deleteAccountCompleted: false,
    deleteAccountLoading: false,
    deleteAccountError: false,
    deleteAccountErrorMessage: '',
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  [DELETION_BEGIN](state) {
    state.deleteAccountLoading = true
    state.deleteAccountCompleted = false
    state.subscriptionErrorMessage = ''
  },
  [DELETION_SUCCESS](state) {
    state.deleteAccountCompleted = true
    state.deleteAccountError = false
    state.deleteAccountLoading = false
  },
  [DELETION_FAILURE](state, error) {
    state.deleteAccountErrorMessage = error
    state.deleteAccountError = true
    state.deleteAccountLoading = false
  },
  [DELETION_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  deleteAccount({ commit, dispatch, getters, rootState }, password) {
    const data = { password: password }
    commit(DELETION_BEGIN)

    return auth.deleteAccount(data).then((response) => {
      commit(DELETION_SUCCESS)
    }).catch((error) => {
      const errorMessage = getErrorMessage(error)
      commit(DELETION_FAILURE, errorMessage)
    })
  },
  clearState({ commit }) {
    commit(DELETION_CLEAR)
  },
}
